var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "250px",
    height: "201px",
    viewBox: "0 0 250 201",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "367AD08E-D3CB-43C4-B1A5-6839FCE705E6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Jobs---Job-Board---Job-Fill---v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Job-Board---5",
    transform: "translate(-603.000000, -416.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JobFill-Feedback",
    transform: "translate(567.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty/confirmation",
    transform: "translate(36.000000, 96.444444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136,64 C139.865993,64 143,67.1340068 143,71 C143,74.8659932 139.865993,78 136,78 L200,78 C203.865993,78 207,81.1340068 207,85 C207,88.8659932 203.865993,92 200,92 L222,92 C225.865993,92 229,95.1340068 229,99 C229,102.865993 225.865993,106 222,106 L203,106 C199.134007,106 196,109.134007 196,113 C196,116.865993 199.134007,120 203,120 L209,120 C212.865993,120 216,123.134007 216,127 C216,130.865993 212.865993,134 209,134 L63,134 C59.1340068,134 56,130.865993 56,127 C56,123.134007 59.1340068,120 63,120 L24,120 C20.1340068,120 17,116.865993 17,113 C17,109.134007 20.1340068,106 24,106 L64,106 C67.8659932,106 71,102.865993 71,99 C71,95.1340068 67.8659932,92 64,92 L39,92 C35.1340068,92 32,88.8659932 32,85 C32,81.1340068 35.1340068,78 39,78 L79,78 C75.1340068,78 72,74.8659932 72,71 C72,67.1340068 75.1340068,64 79,64 L136,64 Z M226,120 C229.865993,120 233,123.134007 233,127 C233,130.865993 229.865993,134 226,134 C222.134007,134 219,130.865993 219,127 C219,123.134007 222.134007,120 226,120 Z",
    id: "BG",
    fill: "#FFD1A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.498238,149.602814 C125.041754,150.306889 128.679232,150.428661 131.311293,150.232849 M135.624444,149.848768 L135.624444,149.848768 C137.906805,149.577776 140.140098,149.146086 142.312775,148.565285 C147.091331,147.287881 151.576674,145.289184 155.645955,142.692475 C159.761453,140.066273 163.451384,136.828398 166.588663,133.10638 C169.32624,129.858561 171.643015,126.242104 173.454551,122.34174 C175.251784,118.472174 176.551725,114.323166 177.271922,109.977459 C177.701077,107.387919 177.924377,104.728535 177.924377,102.016813 C177.924377,98.0355356 177.443046,94.1670723 176.535594,90.4668272 C175.560567,86.4910348 174.093592,82.7094469 172.203154,79.1907892 C169.835638,74.7841464 166.803956,70.7898878 163.242631,67.3430064 C160.471706,64.661125 157.380146,62.3106135 154.031315,60.3550563 C150.261201,58.1534902 146.165014,56.4524992 141.833165,55.3428099 C138.025206,54.3673252 134.035138,53.8487679 129.924377,53.8487679 C124.758433,53.8487679 119.783096,54.667707 115.120252,56.183272 C110.55512,57.6670775 106.289521,59.8186182 102.437839,62.5231104 C98.4695921,65.3094494 94.9406938,68.6827145 91.9762299,72.517382 C88.1339305,77.4875691 85.2398386,83.232878 83.566314,89.4799956 C82.495474,93.4773449 81.9243769,97.6801523 81.9243769,102.016813 C81.9243769,108.90132 83.3636548,115.448489 85.9567327,121.371842 C89.110149,128.575173 93.9698915,134.855959 100.022544,139.698986 C105.102428,143.763653 111.022591,146.815571 117.47951,148.550153",
    id: "Shape",
    stroke: "#D37622",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    transform: "translate(129.924377, 102.082804) rotate(-44.000000) translate(-129.924377, -102.082804) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "bling",
    transform: "translate(166.000000, 45.000000)",
    stroke: "#D37622",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 6,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 14,
    x2: 10.5,
    y2: 20,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 7,
    x2: 3.5,
    y2: 13,
    id: "Line",
    transform: "translate(3.500000, 10.000000) rotate(-90.000000) translate(-3.500000, -10.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 7,
    x2: 17.5,
    y2: 13,
    id: "Line",
    transform: "translate(17.500000, 10.000000) rotate(-90.000000) translate(-17.500000, -10.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "bling",
    transform: "translate(85.000000, 148.000000)",
    stroke: "#D37622",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 0,
    x2: 8.5,
    y2: 4,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 12,
    x2: 8.5,
    y2: 16,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 6,
    x2: 2.5,
    y2: 10,
    id: "Line",
    transform: "translate(2.500000, 8.000000) rotate(-90.000000) translate(-2.500000, -8.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.5,
    y1: 6,
    x2: 14.5,
    y2: 10,
    id: "Line",
    transform: "translate(14.500000, 8.000000) rotate(-90.000000) translate(-14.500000, -8.000000) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.526447,74.4152014 C116.528536,73.5491455 114.450316,72.8342909 112.306106,72.285009 C108.974141,71.4314599 105.482832,70.9777222 101.885916,70.9777222 C100.411476,70.9777222 98.9547817,71.053965 97.5195338,71.202736 M92.781319,71.9707019 C91.4744022,72.2605598 90.1903559,72.6115095 88.9323067,73.0204134 C88.003155,73.3224157 87.0881841,73.6560308 86.1886538,74.0199947",
    id: "Shape",
    stroke: "#D37622",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    transform: "translate(102.357550, 72.696462) rotate(-44.000000) translate(-102.357550, -72.696462) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.980176,101.368519 C109.523876,100.056698 107.264886,100.157416 105.934579,101.593481 C104.604273,103.029546 104.706411,105.257148 106.162711,106.56897 L122.971046,121.709769 C125.009865,123.54632 128.172452,123.405314 130.034881,121.394823 C130.112761,121.309429 130.112761,121.309429 130.187915,121.221692 L154.174662,92.7734851 C155.435707,91.2778891 155.228483,89.0573939 153.711813,87.8138703 C152.195143,86.5703468 149.94336,86.7746919 148.682314,88.270288 L126.130917,115.016174 L110.980176,101.368519 Z",
    id: "Path-7",
    stroke: "#D37622",
    strokeWidth: 2.5,
    fill: "#FFD1A8",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.25b1aad8eaf6ba2f6372d9c87014968b.svg";
export { ForwardRef as ReactComponent };